<div class="orchestrator-box pagina">
  <app-title-box
    [local]="tituloLocal"
    [mostrarBotaoFiltrar]="mostrarBotaoFiltrar"
    (alternarFiltro)="alternarFiltroTitulo()"
  >
    <ng-content select="[orchestrator-title-actions]"></ng-content>
  </app-title-box>

  <app-flash-message></app-flash-message>

  <app-filter-box
    [aberto]="filtroAberto"
    (abertoChange)="filtroAberto = $event"
    (aplicarFiltro)="onAplicarFiltroPainel()"
  >
    <ng-content select="[orchestrator-filter-fields]"></ng-content>
    <!-- Botões secundários do rodapé do filtro (ex.: "Limpar filtros"),
         projetados ao lado do botão "Filtrar" do FilterBox. -->
    <ng-container ngProjectAs="[filter-box-footer-extras]">
      <ng-content select="[orchestrator-filter-footer-extras]"></ng-content>
    </ng-container>
  </app-filter-box>

  <section class="secao-lista">
    <div class="secao-cabecalho">
      <h2>{{ secaoListaTitulo }}</h2>
      <button
        *ngIf="mostrarAbrirFiltrosCodigo"
        mat-button
        color="primary"
        type="button"
        (click)="abrirFiltrosPorCodigo()"
        title="Abrir painel de filtros via ViewChild"
      >
        Abrir filtros (código)
      </button>
    </div>

    <app-list-box
      [itens]="itens"
      [totalRegistros]="totalRegistros"
      [paginaAtual]="paginaAtual"
      [tamanhoPagina]="tamanhoPagina"
      [opcoesTamanhoPagina]="opcoesTamanhoPagina"
      [colunas]="colunas"
      [acoesEngrenagem]="acoesEngrenagem"
      [filtroTextoExibir]="filtroTextoExibir"
      [filtroTextoLabel]="filtroTextoLabel"
      [filtroTextoPlaceholder]="filtroTextoPlaceholder"
      [paginarColunas]="paginarColunas"
      [colunasPorGrupo]="colunasPorGrupo"
      [paginacaoClientSide]="paginacaoClientSide"
      [corLinhaCondicao]="corLinhaCondicao"
      [mostrarPaginador]="mostrarPaginador"
      [ordenacaoExibir]="ordenacaoExibir"
      [ordenacaoServerSide]="ordenacaoServerSide"
      (paginacaoAlterada)="onPaginacaoAlteradaListBox($event)"
      (ordenacaoAlterada)="onOrdenacaoAlteradaListBox($event)"
      (botaoAcaoClicado)="onBotaoAcaoListBox($event)"
      (exportarTodosSolicitado)="onExportarTodosListBox($event)"
      (iconeImagemClicado)="iconeImagemClicado.emit($event)"
    >
    </app-list-box>
  </section>
</div>
